export default __webpack_public_path__ + "static/media/18-Segment-Your-Wi-fi.8715bca6.jpg";